// import service_app from '@/api/modules/service_app';
import service_app from '@/api';
import { exchangeRefreshToken } from '@/api';
import service_eval from '@/api/modules/service_eval';
import axios from 'axios';
import { GlobalStore } from '@/store';

// const isLog = true;
const isLog = false;
// import dummy_report from './dummy/report_eval.json';true false
// const timeout = () => new Promise((resolve) => setTimeout(resolve, 500));

///////////////////-비회원-//////////////////////////////
/*** 진단평가 토큰재발급  ttttest*/
// export const apiReToken4Eval = async (reToken) => {
//     // console.log('--apiReToken4Eval-token:', token);
//     try {
//         const res = await service_app({
//             url: '/api/diagnostic/refresh',
//             method: 'post',
//             data: { token: reToken },
//             headers: { Authorization: `Bearer ${reToken}` },
//         });
//         // console.log('--apiReToken4Eval-DATA:', res);
//         return res;
//     } catch (e) {
//         return e.response ? e.response : null;
//     }
// };
/*** 진단평가 로그인(비회원)  */
export const apiLogin4NonMember = async (params) => {
    // console.log('--requestEvalLogin-params:', params);
    try {
        const res = await service_eval({
            url: '/api/diagnostic/register-temp-user',
            method: 'post',
            data: params,
        });
        // console.log('--requestEvalLogin-DATA:', res);
        return res;
    } catch (e) {
        return e.response ? e.response : null;
    }
};
/** * 진단평가 로그인(회원)  */
export const apiLogin4Member = async (params) => {
    // console.log('param: ', params);
    try {
        const res = await service_app({
            url: '/api/diagnostic/user/start',
            method: 'post',
            ...(params && { data: params }),
        });
        // console.log('--requestEvalLoginForMember-DATA:', res);
        return res;
    } catch (e) {
        return e.response ? e.response : null;
    }
};

/** * 진단평가 지난 OMR list*/
export const apiGetOmrList = async () => {
    try {
        const res = await service_eval({
            url: '/api/diagnostic/prev-reply-list',
            method: 'get',
        });
        // console.log('--getEvalOmr-DATA:', res);
        return res;
    } catch (e) {
        return e.response ? e.response : null;
    }
};

/** * 진단평가 각 문제 결과 제출 */
export const apiSendEachUnit = async (isMem, params) => {
    if (isMem) {
        const resReToken = await exchangeRefreshToken();
        if (resReToken && resReToken.status === 200) {
            try {
                const res = await service_eval({
                    url: '/api/diagnostic/reply',
                    method: 'post',
                    data: params,
                });
                return res;
            } catch (e) {
                return e.response ? e.response : null;
            }
        } else return null;
    } else {
        try {
            const res = await service_eval({
                url: '/api/diagnostic/reply',
                method: 'post',
                data: params,
            });
            return res;
        } catch (e) {
            return e.response ? e.response : null;
        }
    }
};

/** * 진단평가 최종 결과 제출  */
export const apiSendFinalResult = async (finalParam) => {
    try {
        const res = await service_eval({
            url: '/api/diagnostic/submit_result',
            method: 'post',
            data: finalParam,
        });
        return res;
    } catch (e) {
        return e.response ? e.response : null;
    }
};

/**  * 진단평가 리스트(회원)  */
export const apiGetEvalList = async () => {
    try {
        const res = await service_app({
            url: '/api/report-list/diagnostic',
            method: 'get',
        });
        return res;
    } catch (e) {
        return e.response ? e.response : null;
    }
};

/**  * 진단평가 분석리포트 받기(회원)  */
export const apiGetEvalReport4Member = async (diagnosticSeq) => {
    try {
        const res = await service_app({
            url: '/api/report/diagnostic',
            method: 'get',
            params: { diagnosticSeq },
        });
        return res;
    } catch (e) {
        return e.response ? e.response : null;
    }
};

/**  * 진단평가 분석리포트 받기(비회원)  */
export const apiGetEvalReport4NonMember = async (participantName, academyCode) => {
    // await timeout();
    // return dummy_report;
    try {
        const res = await service_eval({
            url: '/api/diagnostic/report',
            method: 'get',
            params: { participantName, academyCode },
        });
        return res;
    } catch (e) {
        return e.response ? e.response : null;
    }
};

//////////////////--------큐뱅크---------/////////////////
/** * Qbank 시험지 정보 가져오기  */
export const getExam = async (params) => {
    const axiosQbank = axios.create({
        // withCredentials: true,
        // timeout: 1000 * 10,
        baseURL: process.env.VUE_APP_QBANK_URL,
    });
    try {
        const res = await axiosQbank({
            url: `/expr/krt/exam/problem/${params.version}/${params.examNm}`,
            method: 'get',
            data: params,
        });
        if (isLog) console.log('-@-getExam-DATA:', res);
        return res;
    } catch (e) {
        return e.response ? e.response : null;
    }
};

/** * Qbank 문항 가져오기  */
export const getUnit = async (params) => {
    const axiosQbank = axios.create({
        // withCredentials: true,
        // timeout: 1000 * 10,
        baseURL: process.env.VUE_APP_QBANK_URL,
    });
    try {
        const res = await axiosQbank({
            url: `/expr/krt/problem/${params.version}/${params.problemId}`,
            method: 'get',
            data: params,
        });
        if (isLog) console.log('-@-getUnit-DATA:', res);
        return res;
    } catch (e) {
        return e.response ? e.response : null;
    }
};

//////////////////-------프리버전_진단평가---------/////////////////
/**  * 프리버전_진단평가 사용자등록  */
export const postDiagnosticRegister = async (params) => {
    const service = axios.create({
        // withCredentials: true,
        // timeout: 1000 * 10,
        baseURL: process.env.VUE_APP_API_URL,
    });
    try {
        const res = await service({
            url: '/api/preview/diagnostic/register',
            method: 'post',
            data: params,
        });
        // console.log('--diag_Register-DATA:', res);
        return res.data;
    } catch (e) {
        return e.response ? e.response : null;
    }
};

/**  * 프리버전_진단평가 결과 제출  */
export const postDiagnosticSubmit = async (params) => {
    const globalStore = GlobalStore();
    const token = globalStore.token;

    const service = axios.create({
        // withCredentials: true,
        // timeout: 1000 * 10,
        baseURL: process.env.VUE_APP_API_URL,
    });
    try {
        const res = await service({
            url: '/api/preview/diagnostic/submit',
            method: 'post',
            data: params,
            headers: { Authorization: `Bearer ${token}` },
        });
        // console.log('--diag_submit-DATA:', res);
        return res.data;
    } catch (e) {
        return e.response ? e.response : null;
    }
};
